 <div class="blog-side">
        <div>
            <h5 class="blog-title">{{ 'Category' | translate }}</h5>
            <div class="sidebar-container borders">
                <ul class="sidebar-list">
                    <li class="d-flex">
                        <a (click)="filterByCategory()" title="{{ 'All' | translate }}">
                            <i class="fa fa-angle-right m-r-15" aria-hidden="true"></i>
                            {{ 'All' | translate }}
                        </a>
                    </li>
                    <li class="d-flex" *ngFor="let category of blogService.categories">
                        <a (click)="filterByCategory(category.category)" [title]="category.category">
                            <i class="fa fa-angle-right m-r-15" aria-hidden="true"></i>
                            {{ category.category }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div>
            <h5 class="blog-title">{{ 'PopularPost' | translate }}</h5>
            <div class="sidebar-container">
                <div class="post-container d-flex" *ngFor="let post of blogService.blogs | slice: 0:6" [routerLink]="['/blog', post.code]" style="cursor: pointer;">
                    <div class="w-35 m-r-10 col-4 p-0">
                        <img [defaultImage]="defaultImage" [lazyLoad]="post.cover" [alt]="post.title" class="img-fluid">
                        <div class="badge">{{ post.createdAt | date: 'yyyy' }}</div>
                    </div>
                    <div class="col-8 p-0">
                        <h5 class="post-head pt-0">{{ post.title }}</h5>
                        <h6 class="date">{{ post.createdAt | date: 'longDate' }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="sidebar-container">
            <h5 class="blog-title">newsletter</h5>
            <div class="newsletter text-center form">
                <div class="form-group"><input type="text" class="form-control" placeholder="enter email">
                    <a href="javascript:void()"> <i class="fa fa-paper-plane" aria-hidden="true"></i> </a></div>
            </div>
        </div> -->
        <!-- <div>
            <h5 class="blog-title">instagram</h5>
            <div class="sidebar-container insta">
                <ul class="blog-insta">
                    <li><a href=""> <img src="assets/images/agency/blog/2.jpg" alt="" class="img-fluid">
                    </a></li>
                    <li><a href=""> <img src="assets/images/agency/blog/3.png" alt="" class="img-fluid">
                    </a></li>
                    <li><a href=""> <img src="assets/images/agency/blog/4.jpg" alt="" class="img-fluid">
                    </a></li>
                    <li><a href=""> <img src="assets/images/agency/blog/6.jpg" alt="" class="img-fluid">
                    </a></li>
                </ul>
                <ul class="blog-insta">
                    <li><a href=""> <img src="assets/images/agency/blog/6.jpg" alt="" class="img-fluid">
                    </a></li>
                    <li><a href=""> <img src="assets/images/agency/blog/4.jpg" alt="" class="img-fluid">
                    </a></li>
                    <li><a href=""> <img src="assets/images/agency/blog/3.png" alt="" class="img-fluid">
                    </a></li>
                    <li><a href=""> <img src="assets/images/agency/blog/2.jpg" alt="" class="img-fluid">
                    </a></li>
                </ul>
            </div>
        </div> -->
</div>